import { useState, useEffect } from 'react';
import { ExperimentToBuckets } from '../static/experiments';
import { getExperiments, getUserBuckets, onUserBucketed, removeOptimizelyListener } from '../services/optimizely';

export type MaybeUserBuckets = Partial<ExperimentToBuckets> | null;

export type OptimizelyData = {
  loaded: boolean;
  data: MaybeUserBuckets;
};

const useOptimizelyData = () => {
  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState<MaybeUserBuckets>(null);
  const [listenerToken, _] = useState(() => Date.now().toString());

  const setUserInfo = async () => {
    const experiments = await getExperiments();

    if (!experiments) {
      console.log('This means no experiments were found');
      return;
    }

    const buckets = getUserBuckets(experiments);

    setData(buckets);
  };

  useEffect(() => {
    setUserInfo().then((_) => setLoaded(true));

    onUserBucketed((_) => setUserInfo(), listenerToken);

    return () => {
      removeOptimizelyListener(listenerToken);
    };
  }, [listenerToken]);

  return {
    loaded,
    data,
  };
};

export default useOptimizelyData;
